import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { TIDS } from "@/lib/testIds";

export const BrandMark = () => (
  <Link to="/" data-testid={TIDS.navLogo} className="flex items-center gap-2 group">
    <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-blue-600 text-white font-bold tracking-tight shadow-sm group-hover:bg-blue-700 transition-colors">BL</span>
    <span className="font-heading font-medium text-slate-900 text-lg tracking-tight">becomelenders<span className="text-blue-600">.com</span></span>
  </Link>
);

export const PublicHeader = () => {
  const role = auth.getRole();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200/80">
      <div className="mx-auto max-w-7xl px-6 md:px-12 h-16 flex items-center justify-between">
        <BrandMark />
        <nav className="flex items-center gap-2 sm:gap-3">
          <Link to="/client/login" data-testid={TIDS.navClientLogin} className="hidden sm:inline-flex text-sm text-slate-600 hover:text-slate-900 px-3 py-2 rounded-md transition-colors">Track Application</Link>
          <Link to="/partner/login" data-testid={TIDS.navPartnerLogin} className="hidden sm:inline-flex text-sm text-slate-600 hover:text-slate-900 px-3 py-2 rounded-md transition-colors">Partner Login</Link>
          {role === "partner" ? (
            <Link to="/partner/dashboard"><Button className="rounded-full bg-blue-600 hover:bg-blue-700">Dashboard</Button></Link>
          ) : role === "admin" ? (
            <Link to="/admin/dashboard"><Button className="rounded-full bg-blue-600 hover:bg-blue-700">Admin Dashboard</Button></Link>
          ) : role === "employee" ? (
            <Link to="/employee/dashboard"><Button className="rounded-full bg-blue-600 hover:bg-blue-700">Team Dashboard</Button></Link>
          ) : role === "client" ? (
            <Link to="/client/dashboard"><Button className="rounded-full bg-emerald-600 hover:bg-emerald-700">My Application</Button></Link>
          ) : (
            <Link to="/partner/signup">
              <Button data-testid={TIDS.navBecomePartner} className="rounded-full bg-blue-600 hover:bg-blue-700 shadow-sm hover:shadow-md transition-all">
                Become a Partner
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export const DashboardShell = ({ children, title, subtitle, actions, role }) => {
  const navigate = useNavigate();
  const user = auth.getUser();
  const logoutId = role === "admin" ? TIDS.adminLogout : role === "employee" ? TIDS.employeeLogout : role === "client" ? TIDS.clientLogout : TIDS.partnerLogout;
  const handleLogout = () => {
    auth.clear();
    navigate("/");
  };
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 md:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <BrandMark />
            <span className="hidden md:inline-block text-xs uppercase tracking-[0.2em] font-semibold text-blue-600">{role === "admin" ? "Admin" : role === "employee" ? "Employee" : role === "client" ? "Client" : "Partner"}</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex flex-col text-right">
              <span className="text-sm font-medium text-slate-900 leading-tight">{user?.full_name || user?.name || user?.email}</span>
              <span className="text-xs text-slate-500 leading-tight">{user?.email || user?.mobile}</span>
            </div>
            <Button variant="outline" onClick={handleLogout} data-testid={logoutId} className="rounded-full">Sign out</Button>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-8 md:py-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <h1 className="text-3xl md:text-4xl font-heading font-medium tracking-tight text-slate-900">{title}</h1>
            {subtitle ? <p className="mt-2 text-slate-600 max-w-2xl">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
        </div>
        {children}
      </div>
    </div>
  );
};
